import {type IconProp} from '@fortawesome/fontawesome-svg-core'
import {
  faArrowDown as faArrowDownLight,
  faArrowDownRight as faArrowDownRightLight,
  faArrowDownToLine as faArrowDownToLineLight,
  faArrowDownWideShort as faArrowDownWideShortLight,
  faArrowLeft as faArrowLeftLight,
  faArrowProgress as faArrowProgressLight,
  faArrowRightArrowLeft as faArrowRightArrowLeftLight,
  faArrowRight as faArrowRightLight,
  faArrowRotateRight as faArrowRotateRightLight,
  faArrowUp as faArrowUpLight,
  faArrowUpRightDots as faArrowUpRightDotsLight,
  faArrowUpRight as faArrowUpRightLight,
  faArrowUpShortWide as faArrowUpShortWideLight,
  faArrowsRotate as faArrowsRotateLight,
  faAtom as faAtomLight,
  faAtomSimple as faAtomSimpleLight,
  faBank as faBankLight,
  faBars as faBarsLight,
  faBell as faBellLight,
  faBookOpenCover as faBookOpenCoverLight,
  faBrainCircuit as faBrainCircuitLight,
  faBrowser as faBrowserLight,
  faBrowsers as faBrowsersLight,
  faBullseyeArrow as faBullseyeArrowLight,
  faCertificate as faCertificateLight,
  faChartWaterfall as faChartWaterfallLight,
  faCheckCircle as faCheckCircleLight,
  faCheck as faCheckLight,
  faChevronDown as faChevronDownLight,
  faChevronLeft as faChevronLeftLight,
  faChevronRight as faChevronRightLight,
  faChevronUp as faChevronUpLight,
  faCircleCheck as faCircleCheckLight,
  faCircleExclamation as faCircleExclamationLight,
  faCircleInfo as faCircleInfoLight,
  faCircle as faCircleLight,
  faCircleNodes as faCircleNodesLight,
  faCircleXmark as faCircleXmarkLight,
  faCopy as faCopyLight,
  faClock as faClockLight,
  faCreditCard as faCreditCardLight,
  faDash as faDashLight,
  faDollar as faDollarLight,
  faEdit as faEditLight,
  faEllipsis as faEllipsisLight,
  faEnvelopeOpenText as faEnvelopeOpenTextLight,
  faFileCheck as faFileCheckLight,
  faFileInvoiceDollar as faFileInvoiceDollarLight,
  faFileInvoice as faFileInvoiceLight,
  faFileLock as faFileLockLight,
  faFileUser as faFileUserLight,
  faFileZipper as faFileZipperLight,
  faFilter as faFilterLight,
  faGear as faGearLight,
  faGears as faGearsLight,
  faGlobe as faGlobeLight,
  faHandHoldingMagic as faHandHoldingMagicLight,
  faHandSparkles as faHandSparklesLight,
  faHandshake as faHandshakeLight,
  faHeart as faHeartLight,
  faImage as faImageLight,
  faInfinity as faInfinityLight,
  faInfoCircle as faInfoCircleLight,
  faLayerGroup as faLayerGroupLight,
  faLightbulb as faLightbulbLight,
  faLink as faLinkLight,
  faLock as faLockLight,
  faMagnifyingGlassDollar as faMagnifyingGlassDollarLight,
  faMagnifyingGlass as faMagnifyingGlassLight,
  faMessagesQuestion as faMessagesQuestionLight,
  faMinus as faMinusLight,
  faMoneyBill as faMoneyBillLight,
  faMoneyBillTransfer as faMoneyBillTransferLight,
  faPaperPlane as faPaperPlaneLight,
  faPaste as faPasteLight,
  faPlus as faPlusLight,
  faReceipt as faReceiptLight,
  faRectangleList as faRectangleListLight,
  faScrewdriverWrench as faScrewdriverWrenchLight,
  faShield as faShieldLight,
  faSparkle as faSparkleLight,
  faSparkles as faSparklesLight,
  faSpinnerThird as faSpinnerThirdLight,
  faStar as faStarLight,
  faTable as faTableLight,
  faUserCheck as faUserCheckLight,
  faUserGroupSimple as faUserGroupSimpleLight,
  faUser as faUserLight,
  faUserTie as faUserTieLight,
  faUsers as faUsersLight,
  faVault as faVaultLight,
  faVolume as faVolumeLight,
  faVolumeSlash as faVolumeSlashLight,
  faXmark as faXmarkLight,
  faCalendar as faCalendarLight,
} from '@fortawesome/pro-light-svg-icons'
import {
  faArrowDown as faArrowDownRegular,
  faArrowDownRight as faArrowDownRightRegular,
  faArrowDownToLine as faArrowDownToLineRegular,
  faArrowDownWideShort as faArrowDownWideShortRegular,
  faArrowLeft as faArrowLeftRegular,
  faArrowProgress as faArrowProgressRegular,
  faArrowRightArrowLeft as faArrowRightArrowLeftRegular,
  faArrowRight as faArrowRightRegular,
  faArrowRotateRight as faArrowRotateRightRegular,
  faArrowUp as faArrowUpRegular,
  faArrowUpRightDots as faArrowUpRightDotsRegular,
  faArrowUpRight as faArrowUpRightRegular,
  faArrowUpShortWide as faArrowUpShortWideRegular,
  faArrowsRotate as faArrowsRotateRegular,
  faAtom as faAtomRegular,
  faAtomSimple as faAtomSimpleRegular,
  faBank as faBankRegular,
  faBars as faBarsRegular,
  faBell as faBellRegular,
  faClock as faClockRegular,
  faBookOpenCover as faBookOpenCoverRegular,
  faBrainCircuit as faBrainCircuitRegular,
  faBrowser as faBrowserRegular,
  faBrowsers as faBrowsersRegular,
  faBullseyeArrow as faBullseyeArrowRegular,
  faCertificate as faCertificateRegular,
  faChartWaterfall as faChartWaterfallRegular,
  faCheckCircle as faCheckCircleRegular,
  faCheck as faCheckRegular,
  faChevronDown as faChevronDownRegular,
  faChevronLeft as faChevronLeftRegular,
  faChevronRight as faChevronRightRegular,
  faChevronUp as faChevronUpRegular,
  faCircleCheck as faCircleCheckRegular,
  faCircleExclamation as faCircleExclamationRegular,
  faCircleInfo as faCircleInfoRegular,
  faCircleNodes as faCircleNodesRegular,
  faCircle as faCircleRegular,
  faCircleXmark as faCircleXmarkRegular,
  faCopy as faCopyRegular,
  faCreditCard as faCreditCardRegular,
  faDash as faDashRegular,
  faDollar as faDollarRegular,
  faEdit as faEditRegular,
  faEllipsis as faEllipsisRegular,
  faEnvelopeOpenText as faEnvelopeOpenTextRegular,
  faFileCheck as faFileCheckRegular,
  faFileInvoiceDollar as faFileInvoiceDollarRegular,
  faFileInvoice as faFileInvoiceRegular,
  faFileLock as faFileLockRegular,
  faFileUser as faFileUserRegular,
  faFileZipper as faFileZipperRegular,
  faFilter as faFilterRegular,
  faGear as faGearRegular,
  faGears as faGearsRegular,
  faGlobe as faGlobeRegular,
  faHandHoldingMagic as faHandHoldingMagicRegular,
  faHandSparkles as faHandSparklesRegular,
  faHandshake as faHandshakeRegular,
  faHeart as faHeartRegular,
  faImage as faImageRegular,
  faInfinity as faInfinityRegular,
  faInfoCircle as faInfoCircleRegular,
  faLayerGroup as faLayerGroupRegular,
  faLightbulb as faLightbulbRegular,
  faLink as faLinkRegular,
  faLock as faLockRegular,
  faMagnifyingGlassDollar as faMagnifyingGlassDollarRegular,
  faMagnifyingGlass as faMagnifyingGlassRegular,
  faMessagesQuestion as faMessagesQuestionRegular,
  faMinus as faMinusRegular,
  faMoneyBill as faMoneyBillRegular,
  faMoneyBillTransfer as faMoneyBillTransferRegular,
  faPaperPlane as faPaperPlaneRegular,
  faPaste as faPasteRegular,
  faPlus as faPlusRegular,
  faReceipt as faReceiptRegular,
  faRectangleList as faRectangleListRegular,
  faScrewdriverWrench as faScrewdriverWrenchRegular,
  faShield as faShieldRegular,
  faSparkle as faSparkleRegular,
  faSparkles as faSparklesRegular,
  faSpinnerThird as faSpinnerThirdRegular,
  faStar as faStarRegular,
  faTable as faTableRegular,
  faUserCheck as faUserCheckRegular,
  faUserGroupSimple as faUserGroupSimpleRegular,
  faUser as faUserRegular,
  faUserTie as faUserTieRegular,
  faUsers as faUsersRegular,
  faVault as faVaultRegular,
  faVolume as faVolumeRegular,
  faVolumeSlash as faVolumeSlashRegular,
  faXmark as faXmarkRegular,
  faCalendar as faCalendarRegular,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faPause as faPauseHeavy,
  faPlay as faPlayHeavy,
  faCaretUp as faCaretUpHeavy,
  faCaretDown as faCaretDownHeavy,
  faSort as faSortHeavy,
} from '@fortawesome/pro-solid-svg-icons'
import {
  faLinkedin as faLinkedinRegular,
  faXTwitter as faXTwitterRegular,
  faFacebookF as faFacebookRegular,
} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {tv, type VariantProps} from 'tailwind-variants'
import {cn, unreachableCase} from '~/design-system/utils'
import Placeholder from './_icons/placeholder.svg'

const iconSize = tv({
  base: 'inline-block overflow-visible text-inherit',
  variants: {
    size: {
      'inherit': '[font-size:inherit]',
      'xs': 'h-[0.75rem] [font-size:0.75rem]',
      'small': 'h-[0.875rem] [font-size:0.875rem]',
      'medium': 'h-[1rem] [font-size:1rem]',
      'large': 'h-[1.125rem] [font-size:1.125rem]',
      'xl': 'h-[1.5rem] [font-size:1.5rem]',
      '2xl': 'h-[2rem] [font-size:2rem]',
    },
    placeholder: {
      true: 'fill-none text-inherit',
    },
  },
})

type HgIconSize = NonNullable<VariantProps<typeof iconSize>['size']>

export const HgCustomIcons = ['placeholder'] as const

export const HgFAUIIcons = [
  'arrow-down',
  'arrow-down-right-angle',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrow-up-right-angle',
  'audio-off',
  'audio-on',
  'calendar',
  'caret-down',
  'caret-up',
  'caret-up-down',
  'checkmark',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'clock',
  'copy',
  'dash',
  'download',
  'edit',
  'ellipsis',
  'error',
  'facebook',
  'file-zipper',
  'filter',
  'info',
  'info-circle',
  'link',
  'linkedin',
  'loading',
  'menu',
  'minus',
  'paste',
  'pause',
  'play',
  'plus',
  'search',
  'settings',
  'user',
  'xmark',
  'xmark-circle',
  'x-twitter',
  'success',
  'star',
] as const

export const HgFADecorativeIcons = [
  'arrow-down-wide-short',
  'arrow-right-arrow-left',
  'arrows-rotate',
  'arrow-rotate-right',
  'arrow-up-short-wide',
  'atom',
  'atom-simple',
  'bank',
  'bell',
  'book-open-cover',
  'brain',
  'browser',
  'browsers',
  'bullseye-arrow',
  'certificate',
  'chart-waterfall',
  'credit-card',
  'circle-check',
  'circle-nodes',
  'dollar',
  'envelope-open-text',
  'file-check',
  'file-invoice',
  'file-lock',
  'file-user',
  'gears',
  'globe',
  'growth-chart',
  'handshake',
  'hand-sparkles',
  'heart',
  'image',
  'infinity',
  'invoice',
  'lightbulb',
  'lock',
  'magnifying-glass-dollar',
  'messages-question',
  'money-bill',
  'money-bill-transfer',
  'paper-plane',
  'pathway',
  'receipt',
  'rectangle-list',
  'screwdriver-wrench',
  'shield',
  'sparkle',
  'sparkles',
  'stack',
  'table',
  'user-check',
  'user-group-simple',
  'user-tie',
  'users',
  'vault',
  'wise-hand',
] as const

type HgFAUIIconType = (typeof HgFAUIIcons)[number]
type HgFADecorativeIconType = (typeof HgFADecorativeIcons)[number]
type HgFAIconType = HgFADecorativeIconType | HgFAUIIconType
type HgCustomIconType = (typeof HgCustomIcons)[number]

export type HgIconType = HgFAIconType | HgCustomIconType

type HgIconProps = {
  className?: string
  iconType: HgIconType
  size: HgIconSize
}

type HgFAIconProps = {
  className?: string
  iconType: HgFAIconType
  size: HgIconSize
}

const FA_UI_ICON_MAP: Record<
  // 'loading' is a special case of 2 FA icons being combined rather than the 1:1 mapping of the other FA icons
  Exclude<HgFAUIIconType, 'loading'>,
  Record<HgIconSize, IconProp>
> = {
  'arrow-down': {
    'inherit': faArrowDownRegular,
    'xs': faArrowDownRegular,
    'small': faArrowDownRegular,
    'medium': faArrowDownRegular,
    'large': faArrowDownLight,
    'xl': faArrowDownLight,
    '2xl': faArrowDownLight,
  },
  'arrow-down-right-angle': {
    'inherit': faArrowDownRightRegular,
    'xs': faArrowDownRightRegular,
    'small': faArrowDownRightRegular,
    'medium': faArrowDownRightRegular,
    'large': faArrowDownRightLight,
    'xl': faArrowDownRightLight,
    '2xl': faArrowDownRightLight,
  },
  'arrow-left': {
    'inherit': faArrowLeftRegular,
    'xs': faArrowLeftRegular,
    'small': faArrowLeftRegular,
    'medium': faArrowLeftRegular,
    'large': faArrowLeftLight,
    'xl': faArrowLeftLight,
    '2xl': faArrowLeftLight,
  },
  'arrow-right': {
    'inherit': faArrowRightRegular,
    'xs': faArrowRightRegular,
    'small': faArrowRightRegular,
    'medium': faArrowRightRegular,
    'large': faArrowRightLight,
    'xl': faArrowRightLight,
    '2xl': faArrowRightLight,
  },
  'arrow-up': {
    'inherit': faArrowUpRegular,
    'xs': faArrowUpRegular,
    'small': faArrowUpRegular,
    'medium': faArrowUpRegular,
    'large': faArrowUpLight,
    'xl': faArrowUpLight,
    '2xl': faArrowUpLight,
  },
  'arrow-up-right-angle': {
    'inherit': faArrowUpRightRegular,
    'xs': faArrowUpRightRegular,
    'small': faArrowUpRightRegular,
    'medium': faArrowUpRightRegular,
    'large': faArrowUpRightLight,
    'xl': faArrowUpRightLight,
    '2xl': faArrowUpRightLight,
  },
  'audio-off': {
    'inherit': faVolumeSlashRegular,
    'xs': faVolumeSlashRegular,
    'small': faVolumeSlashRegular,
    'medium': faVolumeSlashRegular,
    'large': faVolumeSlashLight,
    'xl': faVolumeSlashLight,
    '2xl': faVolumeSlashLight,
  },
  'audio-on': {
    'inherit': faVolumeRegular,
    'xs': faVolumeRegular,
    'small': faVolumeRegular,
    'medium': faVolumeRegular,
    'large': faVolumeLight,
    'xl': faVolumeLight,
    '2xl': faVolumeLight,
  },
  'calendar': {
    'inherit': faCalendarRegular,
    'xs': faCalendarRegular,
    'small': faCalendarRegular,
    'medium': faCalendarRegular,
    'large': faCalendarLight,
    'xl': faCalendarLight,
    '2xl': faCalendarLight,
  },
  'caret-down': {
    'inherit': faCaretDownHeavy,
    'xs': faCaretDownHeavy,
    'small': faCaretDownHeavy,
    'medium': faCaretDownHeavy,
    'large': faCaretDownHeavy,
    'xl': faCaretDownHeavy,
    '2xl': faCaretDownHeavy,
  },
  'caret-up': {
    'inherit': faCaretUpHeavy,
    'xs': faCaretUpHeavy,
    'small': faCaretUpHeavy,
    'medium': faCaretUpHeavy,
    'large': faCaretUpHeavy,
    'xl': faCaretUpHeavy,
    '2xl': faCaretUpHeavy,
  },
  'caret-up-down': {
    'inherit': faSortHeavy,
    'xs': faSortHeavy,
    'small': faSortHeavy,
    'medium': faSortHeavy,
    'large': faSortHeavy,
    'xl': faSortHeavy,
    '2xl': faSortHeavy,
  },
  'checkmark': {
    'inherit': faCheckRegular,
    'xs': faCheckRegular,
    'small': faCheckRegular,
    'medium': faCheckRegular,
    'large': faCheckLight,
    'xl': faCheckLight,
    '2xl': faCheckLight,
  },
  'chevron-down': {
    'inherit': faChevronDownRegular,
    'xs': faChevronDownRegular,
    'small': faChevronDownRegular,
    'medium': faChevronDownRegular,
    'large': faChevronDownLight,
    'xl': faChevronDownLight,
    '2xl': faChevronDownLight,
  },
  'chevron-left': {
    'inherit': faChevronLeftRegular,
    'xs': faChevronLeftRegular,
    'small': faChevronLeftRegular,
    'medium': faChevronLeftRegular,
    'large': faChevronLeftLight,
    'xl': faChevronLeftLight,
    '2xl': faChevronLeftLight,
  },
  'chevron-right': {
    'inherit': faChevronRightRegular,
    'xs': faChevronRightRegular,
    'small': faChevronRightRegular,
    'medium': faChevronRightRegular,
    'large': faChevronRightLight,
    'xl': faChevronRightLight,
    '2xl': faChevronRightLight,
  },
  'chevron-up': {
    'inherit': faChevronUpRegular,
    'xs': faChevronUpRegular,
    'small': faChevronUpRegular,
    'medium': faChevronUpRegular,
    'large': faChevronUpLight,
    'xl': faChevronUpLight,
    '2xl': faChevronUpLight,
  },
  'clock': {
    'inherit': faClockRegular,
    'xs': faClockRegular,
    'small': faClockRegular,
    'medium': faClockRegular,
    'large': faClockLight,
    'xl': faClockLight,
    '2xl': faClockLight,
  },
  'copy': {
    'inherit': faCopyRegular,
    'xs': faCopyRegular,
    'small': faCopyRegular,
    'medium': faCopyRegular,
    'large': faCopyLight,
    'xl': faCopyLight,
    '2xl': faCopyLight,
  },
  'dash': {
    'inherit': faDashRegular,
    'xs': faDashRegular,
    'small': faDashRegular,
    'medium': faDashRegular,
    'large': faDashLight,
    'xl': faDashLight,
    '2xl': faDashLight,
  },
  'download': {
    'inherit': faArrowDownToLineRegular,
    'xs': faArrowDownToLineRegular,
    'small': faArrowDownToLineRegular,
    'medium': faArrowDownToLineRegular,
    'large': faArrowDownToLineLight,
    'xl': faArrowDownToLineLight,
    '2xl': faArrowDownToLineLight,
  },
  'edit': {
    'inherit': faEditRegular,
    'xs': faEditRegular,
    'small': faEditRegular,
    'medium': faEditRegular,
    'large': faEditLight,
    'xl': faEditLight,
    '2xl': faEditLight,
  },
  'ellipsis': {
    'inherit': faEllipsisRegular,
    'xs': faEllipsisRegular,
    'small': faEllipsisRegular,
    'medium': faEllipsisRegular,
    'large': faEllipsisLight,
    'xl': faEllipsisLight,
    '2xl': faEllipsisLight,
  },
  'error': {
    'inherit': faCircleExclamationRegular,
    'xs': faCircleExclamationRegular,
    'small': faCircleExclamationRegular,
    'medium': faCircleExclamationRegular,
    'large': faCircleExclamationLight,
    'xl': faCircleExclamationLight,
    '2xl': faCircleExclamationLight,
  },
  'facebook': {
    'inherit': faFacebookRegular,
    'xs': faFacebookRegular,
    'small': faFacebookRegular,
    'medium': faFacebookRegular,
    'large': faFacebookRegular,
    'xl': faFacebookRegular,
    '2xl': faFacebookRegular,
  },
  'file-zipper': {
    'inherit': faFileZipperRegular,
    'xs': faFileZipperRegular,
    'small': faFileZipperRegular,
    'medium': faFileZipperRegular,
    'large': faFileZipperLight,
    'xl': faFileZipperLight,
    '2xl': faFileZipperLight,
  },
  'filter': {
    'inherit': faFilterRegular,
    'xs': faFilterRegular,
    'small': faFilterRegular,
    'medium': faFilterRegular,
    'large': faFilterLight,
    'xl': faFilterLight,
    '2xl': faFilterLight,
  },
  'info': {
    'inherit': faCircleInfoRegular,
    'xs': faCircleInfoRegular,
    'small': faCircleInfoRegular,
    'medium': faCircleInfoRegular,
    'large': faCircleInfoLight,
    'xl': faCircleInfoLight,
    '2xl': faCircleInfoLight,
  },
  'info-circle': {
    'inherit': faInfoCircleRegular,
    'xs': faInfoCircleRegular,
    'small': faInfoCircleRegular,
    'medium': faInfoCircleRegular,
    'large': faInfoCircleLight,
    'xl': faInfoCircleLight,
    '2xl': faInfoCircleLight,
  },
  'link': {
    'inherit': faLinkRegular,
    'xs': faLinkRegular,
    'small': faLinkRegular,
    'medium': faLinkRegular,
    'large': faLinkLight,
    'xl': faLinkLight,
    '2xl': faLinkLight,
  },
  'linkedin': {
    'inherit': faLinkedinRegular,
    'xs': faLinkedinRegular,
    'small': faLinkedinRegular,
    'medium': faLinkedinRegular,
    'large': faLinkedinRegular,
    'xl': faLinkedinRegular,
    '2xl': faLinkedinRegular,
  },
  'menu': {
    'inherit': faBarsRegular,
    'xs': faBarsRegular,
    'small': faBarsRegular,
    'medium': faBarsRegular,
    'large': faBarsLight,
    'xl': faBarsLight,
    '2xl': faBarsLight,
  },
  'minus': {
    'inherit': faMinusRegular,
    'xs': faMinusRegular,
    'small': faMinusRegular,
    'medium': faMinusRegular,
    'large': faMinusLight,
    'xl': faMinusLight,
    '2xl': faMinusLight,
  },
  'paste': {
    'inherit': faPasteRegular,
    'xs': faPasteRegular,
    'small': faPasteRegular,
    'medium': faPasteRegular,
    'large': faPasteLight,
    'xl': faPasteLight,
    '2xl': faPasteLight,
  },
  'pause': {
    'inherit': faPauseHeavy,
    'xs': faPauseHeavy,
    'small': faPauseHeavy,
    'medium': faPauseHeavy,
    'large': faPauseHeavy,
    'xl': faPauseHeavy,
    '2xl': faPauseHeavy,
  },
  'play': {
    'inherit': faPlayHeavy,
    'xs': faPlayHeavy,
    'small': faPlayHeavy,
    'medium': faPlayHeavy,
    'large': faPlayHeavy,
    'xl': faPlayHeavy,
    '2xl': faPlayHeavy,
  },
  'plus': {
    'inherit': faPlusRegular,
    'xs': faPlusRegular,
    'small': faPlusRegular,
    'medium': faPlusRegular,
    'large': faPlusLight,
    'xl': faPlusLight,
    '2xl': faPlusLight,
  },
  'search': {
    'inherit': faMagnifyingGlassRegular,
    'xs': faMagnifyingGlassRegular,
    'small': faMagnifyingGlassRegular,
    'medium': faMagnifyingGlassRegular,
    'large': faMagnifyingGlassLight,
    'xl': faMagnifyingGlassLight,
    '2xl': faMagnifyingGlassLight,
  },
  'settings': {
    'inherit': faGearRegular,
    'xs': faGearRegular,
    'small': faGearRegular,
    'medium': faGearRegular,
    'large': faGearLight,
    'xl': faGearLight,
    '2xl': faGearLight,
  },
  'star': {
    'inherit': faStarRegular,
    'xs': faStarRegular,
    'small': faStarRegular,
    'medium': faStarRegular,
    'large': faStarLight,
    'xl': faStarLight,
    '2xl': faStarLight,
  },
  'success': {
    'inherit': faCheckCircleRegular,
    'xs': faCheckCircleRegular,
    'small': faCheckCircleRegular,
    'medium': faCheckCircleRegular,
    'large': faCheckCircleLight,
    'xl': faCheckCircleLight,
    '2xl': faCheckCircleLight,
  },
  'user': {
    'inherit': faUserRegular,
    'xs': faUserRegular,
    'small': faUserRegular,
    'medium': faUserRegular,
    'large': faUserLight,
    'xl': faUserLight,
    '2xl': faUserLight,
  },
  'x-twitter': {
    'inherit': faXTwitterRegular,
    'xs': faXTwitterRegular,
    'small': faXTwitterRegular,
    'medium': faXTwitterRegular,
    'large': faXTwitterRegular,
    'xl': faXTwitterRegular,
    '2xl': faXTwitterRegular,
  },
  'xmark': {
    'inherit': faXmarkRegular,
    'xs': faXmarkRegular,
    'small': faXmarkRegular,
    'medium': faXmarkRegular,
    'large': faXmarkLight,
    'xl': faXmarkLight,
    '2xl': faXmarkLight,
  },
  'xmark-circle': {
    'inherit': faCircleXmarkRegular,
    'xs': faCircleXmarkRegular,
    'small': faCircleXmarkRegular,
    'medium': faCircleXmarkRegular,
    'large': faCircleXmarkLight,
    'xl': faCircleXmarkLight,
    '2xl': faCircleXmarkLight,
  },
}

const FA_DECORATIVE_ICON_MAP: Record<
  HgFADecorativeIconType,
  Record<HgIconSize, IconProp>
> = {
  'arrow-down-wide-short': {
    'inherit': faArrowDownWideShortRegular,
    'xs': faArrowDownWideShortRegular,
    'small': faArrowDownWideShortRegular,
    'medium': faArrowDownWideShortRegular,
    'large': faArrowDownWideShortLight,
    'xl': faArrowDownWideShortLight,
    '2xl': faArrowDownWideShortLight,
  },
  'arrow-right-arrow-left': {
    'inherit': faArrowRightArrowLeftRegular,
    'xs': faArrowRightArrowLeftRegular,
    'small': faArrowRightArrowLeftRegular,
    'medium': faArrowRightArrowLeftRegular,
    'large': faArrowRightArrowLeftLight,
    'xl': faArrowRightArrowLeftLight,
    '2xl': faArrowRightArrowLeftLight,
  },
  'arrow-rotate-right': {
    'inherit': faArrowRotateRightRegular,
    'xs': faArrowRotateRightRegular,
    'small': faArrowRotateRightRegular,
    'medium': faArrowRotateRightRegular,
    'large': faArrowRotateRightLight,
    'xl': faArrowRotateRightLight,
    '2xl': faArrowRotateRightLight,
  },
  'arrow-up-short-wide': {
    'inherit': faArrowUpShortWideRegular,
    'xs': faArrowUpShortWideRegular,
    'small': faArrowUpShortWideRegular,
    'medium': faArrowUpShortWideRegular,
    'large': faArrowUpShortWideLight,
    'xl': faArrowUpShortWideLight,
    '2xl': faArrowUpShortWideLight,
  },
  'arrows-rotate': {
    'inherit': faArrowsRotateRegular,
    'xs': faArrowsRotateRegular,
    'small': faArrowsRotateRegular,
    'medium': faArrowsRotateRegular,
    'large': faArrowsRotateLight,
    'xl': faArrowsRotateLight,
    '2xl': faArrowsRotateLight,
  },
  'atom': {
    'inherit': faAtomRegular,
    'xs': faAtomRegular,
    'small': faAtomRegular,
    'medium': faAtomRegular,
    'large': faAtomLight,
    'xl': faAtomLight,
    '2xl': faAtomLight,
  },
  'atom-simple': {
    'inherit': faAtomSimpleRegular,
    'xs': faAtomSimpleRegular,
    'small': faAtomSimpleRegular,
    'medium': faAtomSimpleRegular,
    'large': faAtomSimpleLight,
    'xl': faAtomSimpleLight,
    '2xl': faAtomSimpleLight,
  },
  'bank': {
    'inherit': faBankRegular,
    'xs': faBankRegular,
    'small': faBankRegular,
    'medium': faBankRegular,
    'large': faBankLight,
    'xl': faBankLight,
    '2xl': faBankLight,
  },
  'bell': {
    'inherit': faBellRegular,
    'xs': faBellRegular,
    'small': faBellRegular,
    'medium': faBellRegular,
    'large': faBellLight,
    'xl': faBellLight,
    '2xl': faBellLight,
  },
  'brain': {
    'inherit': faBrainCircuitRegular,
    'xs': faBrainCircuitRegular,
    'small': faBrainCircuitRegular,
    'medium': faBrainCircuitRegular,
    'large': faBrainCircuitLight,
    'xl': faBrainCircuitLight,
    '2xl': faBrainCircuitLight,
  },
  'book-open-cover': {
    'inherit': faBookOpenCoverRegular,
    'xs': faBookOpenCoverRegular,
    'small': faBookOpenCoverRegular,
    'medium': faBookOpenCoverRegular,
    'large': faBookOpenCoverLight,
    'xl': faBookOpenCoverLight,
    '2xl': faBookOpenCoverLight,
  },
  'browser': {
    'inherit': faBrowserRegular,
    'xs': faBrowserRegular,
    'small': faBrowserRegular,
    'medium': faBrowserRegular,
    'large': faBrowserLight,
    'xl': faBrowserLight,
    '2xl': faBrowserLight,
  },
  'browsers': {
    'inherit': faBrowsersRegular,
    'xs': faBrowsersRegular,
    'small': faBrowsersRegular,
    'medium': faBrowsersRegular,
    'large': faBrowsersLight,
    'xl': faBrowsersLight,
    '2xl': faBrowsersLight,
  },
  'bullseye-arrow': {
    'inherit': faBullseyeArrowRegular,
    'xs': faBullseyeArrowRegular,
    'small': faBullseyeArrowRegular,
    'medium': faBullseyeArrowRegular,
    'large': faBullseyeArrowLight,
    'xl': faBullseyeArrowLight,
    '2xl': faBullseyeArrowLight,
  },
  'certificate': {
    'inherit': faCertificateRegular,
    'xs': faCertificateRegular,
    'small': faCertificateRegular,
    'medium': faCertificateRegular,
    'large': faCertificateLight,
    'xl': faCertificateLight,
    '2xl': faCertificateLight,
  },
  'chart-waterfall': {
    'inherit': faChartWaterfallRegular,
    'xs': faChartWaterfallRegular,
    'small': faChartWaterfallRegular,
    'medium': faChartWaterfallRegular,
    'large': faChartWaterfallLight,
    'xl': faChartWaterfallLight,
    '2xl': faChartWaterfallLight,
  },
  'circle-check': {
    'inherit': faCircleCheckRegular,
    'xs': faCircleCheckRegular,
    'small': faCircleCheckRegular,
    'medium': faCircleCheckRegular,
    'large': faCircleCheckLight,
    'xl': faCircleCheckLight,
    '2xl': faCircleCheckLight,
  },
  'circle-nodes': {
    'inherit': faCircleNodesRegular,
    'xs': faCircleNodesRegular,
    'small': faCircleNodesRegular,
    'medium': faCircleNodesRegular,
    'large': faCircleNodesLight,
    'xl': faCircleNodesLight,
    '2xl': faCircleNodesLight,
  },
  'credit-card': {
    'inherit': faCreditCardRegular,
    'xs': faCreditCardRegular,
    'small': faCreditCardRegular,
    'medium': faCreditCardRegular,
    'large': faCreditCardLight,
    'xl': faCreditCardLight,
    '2xl': faCreditCardLight,
  },
  'dollar': {
    'inherit': faDollarRegular,
    'xs': faDollarRegular,
    'small': faDollarRegular,
    'medium': faDollarRegular,
    'large': faDollarLight,
    'xl': faDollarLight,
    '2xl': faDollarLight,
  },
  'envelope-open-text': {
    'inherit': faEnvelopeOpenTextRegular,
    'xs': faEnvelopeOpenTextRegular,
    'small': faEnvelopeOpenTextRegular,
    'medium': faEnvelopeOpenTextRegular,
    'large': faEnvelopeOpenTextLight,
    'xl': faEnvelopeOpenTextLight,
    '2xl': faEnvelopeOpenTextLight,
  },
  'file-check': {
    'inherit': faFileCheckRegular,
    'xs': faFileCheckRegular,
    'small': faFileCheckRegular,
    'medium': faFileCheckRegular,
    'large': faFileCheckLight,
    'xl': faFileCheckLight,
    '2xl': faFileCheckLight,
  },
  'file-invoice': {
    'inherit': faFileInvoiceRegular,
    'xs': faFileInvoiceRegular,
    'small': faFileInvoiceRegular,
    'medium': faFileInvoiceRegular,
    'large': faFileInvoiceLight,
    'xl': faFileInvoiceLight,
    '2xl': faFileInvoiceLight,
  },
  'file-lock': {
    'inherit': faFileLockRegular,
    'xs': faFileLockRegular,
    'small': faFileLockRegular,
    'medium': faFileLockRegular,
    'large': faFileLockLight,
    'xl': faFileLockLight,
    '2xl': faFileLockLight,
  },
  'file-user': {
    'inherit': faFileUserRegular,
    'xs': faFileUserRegular,
    'small': faFileUserRegular,
    'medium': faFileUserRegular,
    'large': faFileUserLight,
    'xl': faFileUserLight,
    '2xl': faFileUserLight,
  },
  'gears': {
    'inherit': faGearsRegular,
    'xs': faGearsRegular,
    'small': faGearsRegular,
    'medium': faGearsRegular,
    'large': faGearsLight,
    'xl': faGearsLight,
    '2xl': faGearsLight,
  },
  'globe': {
    'inherit': faGlobeRegular,
    'xs': faGlobeRegular,
    'small': faGlobeRegular,
    'medium': faGlobeRegular,
    'large': faGlobeLight,
    'xl': faGlobeLight,
    '2xl': faGlobeLight,
  },
  'growth-chart': {
    'inherit': faArrowUpRightDotsRegular,
    'xs': faArrowUpRightDotsRegular,
    'small': faArrowUpRightDotsRegular,
    'medium': faArrowUpRightDotsRegular,
    'large': faArrowUpRightDotsLight,
    'xl': faArrowUpRightDotsLight,
    '2xl': faArrowUpRightDotsLight,
  },
  'handshake': {
    'inherit': faHandshakeRegular,
    'xs': faHandshakeRegular,
    'small': faHandshakeRegular,
    'medium': faHandshakeRegular,
    'large': faHandshakeLight,
    'xl': faHandshakeLight,
    '2xl': faHandshakeLight,
  },
  'hand-sparkles': {
    'inherit': faHandSparklesRegular,
    'xs': faHandSparklesRegular,
    'small': faHandSparklesRegular,
    'medium': faHandSparklesRegular,
    'large': faHandSparklesLight,
    'xl': faHandSparklesLight,
    '2xl': faHandSparklesLight,
  },
  'heart': {
    'inherit': faHeartRegular,
    'xs': faHeartRegular,
    'small': faHeartRegular,
    'medium': faHeartRegular,
    'large': faHeartLight,
    'xl': faHeartLight,
    '2xl': faHeartLight,
  },
  'image': {
    'inherit': faImageRegular,
    'xs': faImageRegular,
    'small': faImageRegular,
    'medium': faImageRegular,
    'large': faImageLight,
    'xl': faImageLight,
    '2xl': faImageLight,
  },
  'infinity': {
    'inherit': faInfinityRegular,
    'xs': faInfinityRegular,
    'small': faInfinityRegular,
    'medium': faInfinityRegular,
    'large': faInfinityLight,
    'xl': faInfinityLight,
    '2xl': faInfinityLight,
  },
  'invoice': {
    'inherit': faFileInvoiceDollarRegular,
    'xs': faFileInvoiceDollarRegular,
    'small': faFileInvoiceDollarRegular,
    'medium': faFileInvoiceDollarRegular,
    'large': faFileInvoiceDollarLight,
    'xl': faFileInvoiceDollarLight,
    '2xl': faFileInvoiceDollarLight,
  },
  'lightbulb': {
    'inherit': faLightbulbRegular,
    'xs': faLightbulbRegular,
    'small': faLightbulbRegular,
    'medium': faLightbulbRegular,
    'large': faLightbulbLight,
    'xl': faLightbulbLight,
    '2xl': faLightbulbLight,
  },
  'lock': {
    'inherit': faLockRegular,
    'xs': faLockRegular,
    'small': faLockRegular,
    'medium': faLockRegular,
    'large': faLockLight,
    'xl': faLockLight,
    '2xl': faLockLight,
  },
  'magnifying-glass-dollar': {
    'inherit': faMagnifyingGlassDollarRegular,
    'xs': faMagnifyingGlassDollarRegular,
    'small': faMagnifyingGlassDollarRegular,
    'medium': faMagnifyingGlassDollarRegular,
    'large': faMagnifyingGlassDollarLight,
    'xl': faMagnifyingGlassDollarLight,
    '2xl': faMagnifyingGlassDollarLight,
  },
  'messages-question': {
    'inherit': faMessagesQuestionRegular,
    'xs': faMessagesQuestionRegular,
    'small': faMessagesQuestionRegular,
    'medium': faMessagesQuestionRegular,
    'large': faMessagesQuestionLight,
    'xl': faMessagesQuestionLight,
    '2xl': faMessagesQuestionLight,
  },
  'money-bill': {
    'inherit': faMoneyBillRegular,
    'xs': faMoneyBillRegular,
    'small': faMoneyBillRegular,
    'medium': faMoneyBillRegular,
    'large': faMoneyBillLight,
    'xl': faMoneyBillLight,
    '2xl': faMoneyBillLight,
  },
  'money-bill-transfer': {
    'inherit': faMoneyBillTransferRegular,
    'xs': faMoneyBillTransferRegular,
    'small': faMoneyBillTransferRegular,
    'medium': faMoneyBillTransferRegular,
    'large': faMoneyBillTransferLight,
    'xl': faMoneyBillTransferLight,
    '2xl': faMoneyBillTransferLight,
  },
  'paper-plane': {
    'inherit': faPaperPlaneRegular,
    'xs': faPaperPlaneRegular,
    'small': faPaperPlaneRegular,
    'medium': faPaperPlaneRegular,
    'large': faPaperPlaneLight,
    'xl': faPaperPlaneLight,
    '2xl': faPaperPlaneLight,
  },
  'pathway': {
    'inherit': faArrowProgressRegular,
    'xs': faArrowProgressRegular,
    'small': faArrowProgressRegular,
    'medium': faArrowProgressRegular,
    'large': faArrowProgressLight,
    'xl': faArrowProgressLight,
    '2xl': faArrowProgressLight,
  },
  'receipt': {
    'inherit': faReceiptRegular,
    'xs': faReceiptRegular,
    'small': faReceiptRegular,
    'medium': faReceiptRegular,
    'large': faReceiptLight,
    'xl': faReceiptLight,
    '2xl': faReceiptLight,
  },
  'rectangle-list': {
    'inherit': faRectangleListRegular,
    'xs': faRectangleListRegular,
    'small': faRectangleListRegular,
    'medium': faRectangleListRegular,
    'large': faRectangleListLight,
    'xl': faRectangleListLight,
    '2xl': faRectangleListLight,
  },
  'screwdriver-wrench': {
    'inherit': faScrewdriverWrenchRegular,
    'xs': faScrewdriverWrenchRegular,
    'small': faScrewdriverWrenchRegular,
    'medium': faScrewdriverWrenchRegular,
    'large': faScrewdriverWrenchLight,
    'xl': faScrewdriverWrenchLight,
    '2xl': faScrewdriverWrenchLight,
  },
  'shield': {
    'inherit': faShieldRegular,
    'xs': faShieldRegular,
    'small': faShieldRegular,
    'medium': faShieldRegular,
    'large': faShieldLight,
    'xl': faShieldLight,
    '2xl': faShieldLight,
  },
  'sparkle': {
    'inherit': faSparkleRegular,
    'xs': faSparkleRegular,
    'small': faSparkleRegular,
    'medium': faSparkleRegular,
    'large': faSparkleLight,
    'xl': faSparkleLight,
    '2xl': faSparkleLight,
  },
  'sparkles': {
    'inherit': faSparklesRegular,
    'xs': faSparklesRegular,
    'small': faSparklesRegular,
    'medium': faSparklesRegular,
    'large': faSparklesLight,
    'xl': faSparklesLight,
    '2xl': faSparklesLight,
  },
  'stack': {
    'inherit': faLayerGroupRegular,
    'xs': faLayerGroupRegular,
    'small': faLayerGroupRegular,
    'medium': faLayerGroupRegular,
    'large': faLayerGroupLight,
    'xl': faLayerGroupLight,
    '2xl': faLayerGroupLight,
  },
  'table': {
    'inherit': faTableRegular,
    'xs': faTableRegular,
    'small': faTableRegular,
    'medium': faTableRegular,
    'large': faTableLight,
    'xl': faTableLight,
    '2xl': faTableLight,
  },
  'user-check': {
    'inherit': faUserCheckRegular,
    'xs': faUserCheckRegular,
    'small': faUserCheckRegular,
    'medium': faUserCheckRegular,
    'large': faUserCheckLight,
    'xl': faUserCheckLight,
    '2xl': faUserCheckLight,
  },
  'user-group-simple': {
    'inherit': faUserGroupSimpleRegular,
    'xs': faUserGroupSimpleRegular,
    'small': faUserGroupSimpleRegular,
    'medium': faUserGroupSimpleRegular,
    'large': faUserGroupSimpleLight,
    'xl': faUserGroupSimpleLight,
    '2xl': faUserGroupSimpleLight,
  },
  'user-tie': {
    'inherit': faUserTieRegular,
    'xs': faUserTieRegular,
    'small': faUserTieRegular,
    'medium': faUserTieRegular,
    'large': faUserTieLight,
    'xl': faUserTieLight,
    '2xl': faUserTieLight,
  },
  'users': {
    'inherit': faUsersRegular,
    'xs': faUsersRegular,
    'small': faUsersRegular,
    'medium': faUsersRegular,
    'large': faUsersLight,
    'xl': faUsersLight,
    '2xl': faUsersLight,
  },
  'vault': {
    'inherit': faVaultRegular,
    'xs': faVaultRegular,
    'small': faVaultRegular,
    'medium': faVaultRegular,
    'large': faVaultLight,
    'xl': faVaultLight,
    '2xl': faVaultLight,
  },
  'wise-hand': {
    'inherit': faHandHoldingMagicRegular,
    'xs': faHandHoldingMagicRegular,
    'small': faHandHoldingMagicRegular,
    'medium': faHandHoldingMagicRegular,
    'large': faHandHoldingMagicLight,
    'xl': faHandHoldingMagicLight,
    '2xl': faHandHoldingMagicLight,
  },
} as const

const SANCTIONED_FA_ICON_MAP: Record<
  Exclude<HgFAIconType, 'loading'>,
  Record<HgIconSize, IconProp>
> = {
  ...FA_UI_ICON_MAP,
  ...FA_DECORATIVE_ICON_MAP,
}

const LoadingFaIcon = ({size}: {size: HgIconSize}) => {
  return (
    <div className="grid">
      <FontAwesomeIcon
        className={iconSize({
          size,
          className:
            'col-start-1 col-end-auto row-start-1 row-end-auto text-inherit opacity-25',
        })}
        icon={size === 'large' ? faCircleLight : faCircleRegular}
      />
      <FontAwesomeIcon
        className={iconSize({
          size,
          className:
            'z-1 col-start-1 col-end-auto row-start-1 row-end-auto animate-spin text-inherit',
        })}
        icon={size === 'large' ? faSpinnerThirdLight : faSpinnerThirdRegular}
      />
    </div>
  )
}

const HgFAIcon = ({className, iconType, size}: HgFAIconProps) => {
  if (iconType === 'loading') {
    return <LoadingFaIcon size={size} />
  }

  return (
    <FontAwesomeIcon
      className={iconSize({size, className})}
      icon={SANCTIONED_FA_ICON_MAP[iconType]?.[size]}
    />
  )
}

function isHgFAIcon(iconType: HgIconType): iconType is HgFAIconType {
  return [...HgFAUIIcons, ...HgFADecorativeIcons].includes(iconType as HgFAIconType)
}

function isHgCustomIcon(iconType: HgIconType): iconType is HgCustomIconType {
  return HgCustomIcons.includes(iconType as HgCustomIconType)
}

const HgIcon = ({className, iconType, size}: HgIconProps) => {
  if (isHgFAIcon(iconType)) {
    return (
      <HgFAIcon
        className={cn(className, iconType === 'play' && 'relative -right-1')}
        iconType={iconType}
        size={size}
      />
    )
  }

  if (isHgCustomIcon(iconType)) {
    switch (iconType) {
      case 'placeholder':
        return (
          <Placeholder
            className={iconSize({size, placeholder: true, class: className})}
          />
        )
      default:
        return null
    }
  }

  return unreachableCase(iconType)
}

export default HgIcon
